import Box from '@mui/material/Box'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import MenuItem from '@mui/material/MenuItem'
import type { MenuItemProps } from '@mui/material/MenuItem'
import ContainsIcon from 'components/UI/icons/ContainsIcon'
import DoesNotContainIcon from 'components/UI/icons/DoesNotContainIcon'
import StartsWithIcon from 'components/UI/icons/StartsWithIcon'
import EndsWithIcon from 'components/UI/icons/EndsWithIcon'
import EqualsIcon from 'components/UI/icons/EqualsIcon'
import DoesNotEqualIcon from 'components/UI/icons/DoesNotEqualIcon'
import GreaterThanIcon from 'components/UI/icons/GreaterThanIcon'
import GreaterThanOrEqualIcon from 'components/UI/icons/GreaterThanOrEqualIcon'
import LessThanIcon from 'components/UI/icons/LessThanIcon'
import LessThanOrEqualIcon from 'components/UI/icons/LessThanOrEqualIcon'
import BlankIcon from 'components/UI/icons/BlankIcon'
import NotBlankIcon from 'components/UI/icons/NotBlankIcon'
import ListIcon from 'components/UI/icons/ListIcon'
import NotInListIcon from 'components/UI/icons/NotInListIcon'


type LeadTableFilterOperatorOptionProps = MenuItemProps & {
  native?: boolean
}

export function iconForOperator(label: string) {
  switch (label) {
    case 'is any of':
      return <ListIcon />
    case 'is not any of':
      return <NotInListIcon />
    case 'contains':
      return <ContainsIcon />
    case 'does not contain':
      return <DoesNotContainIcon />
    case 'starts with':
      return <StartsWithIcon />
    case 'ends with':
      return <EndsWithIcon />
    case '=':
    case 'equals':
      return <EqualsIcon />
    case '!=':
    case 'does not equal':
      return <DoesNotEqualIcon />
    case '>':
      return <GreaterThanIcon />
    case '>=':
      return <GreaterThanOrEqualIcon />
    case '<':
      return <LessThanIcon />
    case '<=':
      return <LessThanOrEqualIcon />
    case 'is empty':
      return <BlankIcon />
    case 'is not empty':
      return <NotBlankIcon />
    default:
      return null
  }
}

export function displayOperatorLabel(label: string) {
  switch (label) {
    case '=':
      return 'equals'
    case '!=':
      return 'does not equal'
    case '>':
      return 'greater than'
    case '>=':
      return 'greater than or equal'
    case '<':
      return 'less than'
    case '<=':
      return 'less than or equal'
    default:
      return label
  }
}

export default function LeadTableFilterOperatorOption({
  children,
  native: _native,
  sx,
  ...props
}: LeadTableFilterOperatorOptionProps) {
  const icon = typeof children === 'string' ? iconForOperator(children) : null
  const label = typeof children === 'string' ? displayOperatorLabel(children) : children

  const menuItemSx = {
    minHeight: 28,
    py: 0,
    fontSize: '14px',
    lineHeight: '28px',

    '& .MuiTypography-root, & .MuiListItemText-primary': {
      fontSize: '14px',
      lineHeight: '28px',
    },
  }

  const combinedSx = [menuItemSx, ...(Array.isArray(sx) ? sx : [sx])]

  if (!icon) {
    return (
      <MenuItem {...props} sx={combinedSx}>
        {label}
      </MenuItem>
    )
  }

  return (
    <MenuItem {...props} sx={combinedSx}>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <ListItemIcon sx={{ minWidth: 32 }}>{icon}</ListItemIcon>
        <ListItemText primary={label} />
      </Box>
    </MenuItem>
  )
}
